export default __webpack_public_path__ + "static/media/diet-img.a65e6ee5.png";